import { Location } from 'src/types/schema/graphql'
import { parseLocationLabel } from 'src/util/helpers'
import { ICombinedData } from '../types/ICombinedData'

export const parseLocations = (locs: Location[]): ICombinedData[] =>
    locs
        ?.filter((loc) => loc?.traits?.isOpenToPublic)
        ?.map((item) => ({
            label:
                item?.title === 'Main Brewery' || item?.title !== ''
                    ? item?.brand?.displayTitle || item?.brand?.title
                    : item?.title,
            value:
                item?.title === 'Main Brewery' || item?.title !== ''
                    ? item?.brand?.displayTitle || item?.title
                    : item?.title,
            coordinates: [item.address?.geo?.lon, item.address?.geo?.lat],
            id: item?.id,
            type: 'location',
            location: item,
        }))
